// @ts-check

// /**
//  * @typedef {{
//  *  companyLogo: string,
//  *  companyLogoAltText: string,
//  * articleTitle: string,
//  * articleSummary: string,
//  * articleLink: string,
//  * }} NewsInfo
//  */

// /**
//  * @type {[]<NewsInfo>}
//  */

export const newsInfo = [
  {
    companyLogo: 'longhorn-100-logo.jpg',
    companyLogoAltText: 'Longhorn 100 logo',
    articleTitle: '2026 Longhorn 100 — #29 Fastest Growing Longhorn Business',
    articleSummary:
      'Evry Health was named #29 on the 2026 Longhorn 100, which showcases and celebrates the entrepreneurial spirit of UT alumni by recognizing the 100 fastest-growing Longhorn businesses in the world.',
    articleLink: 'https://www.texasexes.org/longhorn100/2026',
  },
  {
    companyLogo: 'D-Magazine-Logo.png',
    companyLogoAltText: 'D Magazine Logo',
    articleTitle:
      "Inside Evry Health's Push to Streamline Prior Authorization Through AI",
    articleSummary:
      "With denial rates at 4 percent in 2025, the Dallas-based, tech-forward insurer is outperforming national averages.",
    articleLink:
      'https://www.dmagazine.com/healthcare-business/2026/05/inside-evry-healths-push-to-streamline-prior-authorization-through-ai/',
  },
  {
    companyLogo: 'dallas_business_journal_logo.jpeg',
    companyLogoAltText: 'Dallas Business Journal logo',
    articleTitle: 'Dallas Business Journal C-Suite Leaders Award',
    articleSummary:
      "Evry Health's CEO, Chris Gay, is one of thirty honorees.",
    articleLink:
      'https://www.bizjournals.com/dallas/news/2025/08/27/2025-c-suite-leaders-awards-winners-revealed.html',
  },
  {
    companyLogo: 'beckers_payer_issues_podcast_logo.png',
    companyLogoAltText: 'beckers payer issues podcast logo',
    articleTitle:
      'Rethinking Prior Authorization Through Technology and Alignment with Chris Gay of Evry Health',
    articleSummary:
      'What if we could eliminate prior authorizations altogether? We discuss PAs, WISeR, and state versus federal regulation. Listen on Apple Podcasts or Spotify.',
    articleLink:
      'https://podcasts.apple.com/us/podcast/rethinking-prior-authorization-through-technology-and/id1519506579?i=1000743205904',
    linkText: 'Listen',
  },
  {
    companyLogo: 'ceo_spotlight_podcast_logo.png',
    companyLogoAltText: 'ceo spotlight podcast logo',
    articleTitle: 'KLRD 1080 AM, CEO Spotlight',
    articleSummary:
      "Healthcare is Ill: David Johnson of Dallas' KLRD radio interviews Chris Gay on July 25, 2025, for the CEO Spotlight.",
    articleLink:
      'https://www.audacy.com/podcast/ceo-spotlight-34d13/episodes/healthcare-is-ill-b47a6',
    linkText: 'Listen',
  },
  {
    companyLogo: 'beckers_payer_issues_podcast_logo.png',
    companyLogoAltText: 'beckers payer issues podcast logo',
    articleTitle: 'Chris Gay, CEO of Evry Health',
    articleSummary:
      'Chris Gay, CEO of Evry Health, joins the podcast to discuss how his organization is enhancing the patient experience and advancing population health. He explores how innovative technology is being used to address persistent challenges in the payer space and improve health outcomes. Gay also shares insights into building a more efficient, patient-centered healthcare system through digital transformation.',
    articleLink:
      'https://podcasts.apple.com/us/podcast/chris-gay-ceo-of-evry-health/id1519506579?i=1000715809623',
    linkText: 'Listen',
  },
  {
    companyLogo: 'beckers-payer-issues-logo.png',
    companyLogoAltText: 'beckers payer issues logo',
    articleTitle:
      'How a Texas payer cut prior auth denials to 7% ahead of industry reform pledge',
    articleSummary:
      'Ahead of the health insurance industry’s broader pledge to overhaul prior authorization processes, one Texas payer has already achieved a 7% prior authorization denial rate, with 100% of those denials upheld upon appeal.',
    articleLink:
      'https://www.beckerspayer.com/payer/how-a-texas-payer-cut-prior-auth-denials-to-7-ahead-of-industry-reform-pledge/',
  },
  {
    companyLogo: 'ahip-logo.png',
    companyLogoAltText: 'ahip logo',
    articleTitle:
      'Health plans are making voluntary commitments to support patients and providers.',
    articleSummary:
      'The undersigned health plans commit to actions that will make health care faster and simpler.',
    articleLink:
      'https://www.ahip.org/health-plans-are-making-voluntary-commitments-to-support-patients-and-providers',
  },
  {
    companyLogo: 'bhbusiness-logo.png',
    companyLogoAltText: 'bh business logo',
    articleTitle:
      'Prior Authorization Overhaul to Debut in 2026, with Broader Reform for Behavioral Health on the Horizon',
    articleSummary:
      'Preventing unnecessary care and medication prescriptions is the primary purpose of prior authorization. Instead, it has all too often led to slower, burdensome delays to critical care for mental health and substance use treatment, but that could soon change.',
    articleLink:
      'https://bhbusiness.com/2025/06/24/prior-authorization-overhaul-to-debut-in-2026-with-broader-reform-for-behavioral-health-on-the-horizon/',
  },
  {
    companyLogo: 'Dallas-Innovates-logo.png',
    companyLogoAltText: 'Dallas Innovates Logo',
    articleTitle:
      'Evry Health Names Air Force Veteran Healthcare Leader as Chief Medical Officer',
    articleSummary:
      'Glenn Hamilton, MD—who held the role of chief medical officer at the San Antonio Air Logistics Center during Desert Storm—will oversee all aspects of population health, utilization management, and clinical policy at Evry Health, the Dallas-based company said.',
    articleLink:
      'https://dallasinnovates.com/evry-health-names-air-force-veteran-healthcare-leader-as-chief-medical-officer/',
  },
  {
    companyLogo: 'dallas-morning-news-logo.png',
    companyLogoAltText: 'The Dallas Morning News Logo',
    articleTitle: 'McKinney-based Globe Life moving to new HQ',
    articleSummary:
      'Globe Life announced plans Monday to acquire a Class AA, six-story, 200,000-square-foot office building at 7677 Henneman Way and two adjacent tracts of land. SouthState Bank is the seller in the transaction, Globe Life said.',
    articleLink:
      'https://www.dallasnews.com/business/real-estate/2025/02/03/mckinney-based-globe-life-moving-to-new-hq/',
  },
  {
    companyLogo: 'D-Magazine-Logo.png',
    companyLogoAltText: 'D Magazine Logo',
    articleTitle: 'Evry Health Names Chief Growth Officer',
    articleSummary:
      'Evry Health, a leading tech-forward business-to-business health insurance company, has named Christina Rassi its new Chief Growth Officer. With over two decades of experience with health insurance carriers.',
    articleLink:
      'https://www.dmagazine.com/healthcare-business/2024/03/evry-health-names-chief-growth-officer-and-unt-regents-approve-nursing-degree-programs/',
  },
  {
    companyLogo: 'Business-Wire-Logo.png',
    companyLogoAltText: 'Business Wire Logo',
    articleTitle:
      'Evry Health Welcomes Veteran Healthcare Leader as New Chief Growth Officer',
    articleSummary:
      'Evry Health, a tech-forward business-to-business health insurance company, announced the appointment of its new Chief Growth Officer, Christina Rassi.',
    articleLink: 'https://www.businesswire.com/news/home/20240318523183/en/',
  },
  {
    companyLogo: 'Dallas-Innovates-logo.png',
    companyLogoAltText: 'Dallas Innovates Logo',
    articleTitle: 'Evry Health Appoints New Chief Growth Officer',
    articleSummary:
      'The leadership addition of Christina Rassi as chief growth officer adds further momentum for Dallas-based Evry Health, following its acquisition by Globe Life last fall.',
    articleLink:
      'https://dallasinnovates.com/evry-health-appoints-new-chief-growth-officer/',
  },
  {
    companyLogo: 'D-CEO-LOGO.png',
    companyLogoAltText: 'D CEO logo',
    articleTitle: 'Meet the Dallas 500',
    articleSummary:
      'Chris Gay is on a mission to digitize health insurance in his role as CEO of Evry Health.',
    articleLink:
      'https://www.dmagazine.com/healthcare-business/2024/02/meet-the-500-chris-gay-evry-health/',
  },
  {
    companyLogo: 'Icon-for-The-Vax-Show.png',
    companyLogoAltText: 'The vax show logo',
    articleTitle: 'Chris Gay on The Vax Show',
    articleSummary:
      'This week Chris Gay shows us health insurance with ZEROS in the right place for a change! Zero office visit cost. Zero prescription cost. Zero tele-health cost, and a lot more.',
    articleLink:
      'https://www.linkedin.com/posts/thevax_ep4-this-week-chris-gay-shows-us-health-activity-7157839546540257280-oBu0',
  },
  {
    companyLogo: 'Icon-for-Dallas-500.png',
    companyLogoAltText: 'D CEO logo',
    articleTitle: "Evry Health and Chris Gay named to D CEO's Dallas 500",
    articleSummary:
      'Meet the most powerful business leaders in Dallas-Fort Worth.',
    articleLink:
      'https://www.dmagazine.com/dallas-500-2024/chapter/healthcare/',
  },
  {
    companyLogo: 'D-Magazine-Logo.png',
    companyLogoAltText: 'D Magazine Logo',
    articleTitle:
      "Globe Life's Acquisition of Evry Health is Rocket Fuel to its Tech-first Approach",
    articleSummary:
      'Amid all the Texas Rangers celebrations at Globe Life Park, the McKinney-based insurance company with the rights to the World Series Champion’s stadium made a local acquisition that gives innovative Evry Health a capital injection, allowing it to expand its disruptive approach to health insurance.',
    articleLink:
      'https://www.dmagazine.com/healthcare-business/2023/11/globe-lifes-acquisition-of-evry-health-is-rocket-fuel-to-its-tech-first-approach/',
  },
  {
    companyLogo: 'Business-Wire-Logo.png',
    companyLogoAltText: 'Business Wire Logo',
    articleTitle:
      'How Quit Genius, Evry Health’s 100% At-Risk Deal Prioritizes Engagement and Clinical Outcomes',
    articleSummary:
      'Digital behavioral health companies are getting creative with contracting to meet the demands of payers and employers.',
    articleLink:
      'https://bhbusiness.com/2023/04/11/how-quit-genius-evry-healths-100-at-risk-deal-prioritizes-engagement-and-clinical-outcomes/',
  },
  {
    companyLogo: 'Dallas-Innovates-logo.png',
    companyLogoAltText: 'Dallas Innovates Logo',
    articleTitle:
      'Globe Life Acquires Dallas-based Mobile-first Insurance Startup Evry Health',
    articleSummary:
      "Dallas-based Evry Health launched out of stealth in December 2021 to make signing up for healthcare or paying a doctor’s bill 'as easy as ordering a pizza.' Less than two years later, it's becoming part of the Globe Life family of brands.",
    articleLink:
      'https://dallasinnovates.com/dallas-based-evry-health-wants-to-make-accessing-healthcare-as-easy-as-ordering-a-pizza/',
  },
  {
    companyLogo: 'Authority-Magazine-Logo.png',
    companyLogoAltText: 'Authority Magazine logo',
    articleTitle:
      'Thriving as a Woman in a Male-Dominated Industry:  Dr. Mamata Majmundar of Evry Health.',
    articleSummary:
      'Be passionate, patient, driven, detail-oriented and have a desire to learn new things.',
    articleLink:
      'https://medium.com/authority-magazine/thriving-as-a-woman-in-a-male-dominated-industry-dr-mamata-majmundar-of-evry-health-on-the-five-90895afd7453',
  },
  {
    companyLogo: 'Business-Wire-Logo.png',
    companyLogoAltText: 'Business Wire Logo',
    articleTitle:
      "CareJourney Launches Provider Performance on the Salesforce AppExchange, the World's Leading Enterprise Cloud Marketplace",
    articleSummary:
      'Customers can now benefit from cost and quality metrics for every provider in the U.S. integrated directly in their Salesforce workflows',
    articleLink:
      'https://www.businesswire.com/news/home/20220914005237/en/CareJourney-Launches-Provider-Performance-on-the-Salesforce-AppExchange-the-Worlds-Leading-Enterprise-Cloud-Marketplace',
  },
  {
    companyLogo: 'PR_Newswire_Navy_Logo.png',
    companyLogoAltText: 'PR Newswire Logo',
    articleTitle: 'Globe Life Acquires Evry Health',
    articleSummary:
      'Founded in 2017, Evry Health is a business-to-business health insurance company that differentiates itself from traditional PPOs and HMOs by lowering the cost of healthcare through software automation with a mobile-first experience.',
    articleLink:
      'https://www.prnewswire.com/news-releases/globe-life-acquires-evry-health-301956623.html',
  },
  {
    companyLogo: 'Evry_Health_Type_Only_ RGB_BLUE.svg',
    companyLogoAltText: 'Evry health globe life Logo',
    articleTitle: 'Evry Health Sponsors 2023 HR Southwest Conference.',
    articleSummary:
      'Exciting news! We are proud to be the Titanium sponsor of the HR Southwest Conference in Ft Worth, Texas this year!',
    articleLink:
      'https://www.linkedin.com/feed/update/urn:li:activity:7115697164516827137',
  },
  {
    companyLogo: 'Insurance-News-Net-Logo.png',
    companyLogoAltText: 'InsuranceNewsNet Logo',
    articleTitle:
      'Health Tech Disruptor Evry Health Reshapes the Payer Landscape Assisted by PLEXIS Next-Gen CAPS Technology.',
    articleSummary:
      'Evry Health, a new B2B health insurance company, has eliminated deductibles and co-pays by employing a smarter product design driving robust automation.',
    articleLink:
      'https://insurancenewsnet.com/oarticle/health-tech-disruptor-evry-health-reshapes-the-payer-landscape-assisted-by-plexis-next-gen-caps-technology',
  },
  {
    companyLogo: 'Business-Wire-Logo.png',
    companyLogoAltText: 'Business Wire Logo',
    articleTitle:
      'Business Health Insurance Company Evry Health Expands Texas Coverage to Austin, San Antonio and Houston',
    articleSummary:
      'DALLAS--(BUSINESS WIRE)--Evry Health, a tech-savvy employer health insurance company, announced today it has expanded its reliable, value-based health care to Austin, Houston and San Antonio. Launched earlier this year with a focus on the Dallas-Fort Worth (DFW) business-to-business market, Evry Health is transforming the healthcare industry with its software automation yielding lowered healthcare costs for businesses, in addition to its model of no deductibles or copays for in-network care and its expansive, tailor-made benefit plans and rewards programs that encourage preventative health and access to care.',
    articleLink:
      'https://www.businesswire.com/news/home/20220718005669/en/Business-Health-Insurance-Company-Evry-Health-Expands-Texas-Coverage-to-Austin-San-Antonio-and-Houston',
  },
  {
    companyLogo: 'Authority-Magazine-Logo.png',
    companyLogoAltText: 'Authority Magazine Logo',
    articleTitle:
      "Health Tech: Chris Gay On How Evry Health's Technology Can Make An Important Impact On Our Overall Wellness",
    articleSummary:
      'Inrecent years, Big Tech has gotten a bad rep. But of course many tech companies are doing important work making monumental positive changes to society, health, and the environment.',
    articleLink:
      'https://medium.com/authority-magazine/health-tech-chris-gay-on-how-evry-healths-technology-can-make-an-important-impact-on-our-overall-5e16fb45b170',
  },
  {
    companyLogo: 'Benefits-Pro-Magazine-Logo.png',
    companyLogoAltText: 'BenefitsPRO Magazine Logo',
    articleTitle:
      '5 things employers should consider when changing health plans',
    articleSummary:
      'Buying or changing health insurance plans is a major decision. With so many products and services on the market, it can be difficult to consider what benefits and services employees want coupled with the best care options available at differing price tiers.',
    articleLink:
      'https://www.benefitspro.com/2022/06/17/5-things-employers-should-consider-when-changing-health-plans/?slreturn=20220901092848',
  },
  {
    companyLogo: 'Start-Up-to-Follow-Logo.png',
    companyLogoAltText: 'Startup to Follow Logo',
    articleTitle:
      'This Health Tech Company is Revolutionizing the Health Insurance Industry',
    articleSummary:
      'Evry Health is a B2B tech-savvy health insurance company that makes health insurance affordable, accessible and high-quality.',
    articleLink:
      'https://www.startuptofollow.com/article/this-health-tech-company-is-revolutionizing-the-health-insurance-industry',
  },
  {
    companyLogo: 'GlobeNewswire-Logo.png',
    companyLogoAltText: 'GlobeNewswire Logo',
    articleTitle:
      'Digital Clinic for Addiction Quit Genius and Tech-Savvy Health Insurance Company Evry Health Partner to Address Drug Addiction and Behavior Modification Head On',
    articleSummary:
      "NEW YORK and DALLAS, April 06, 2022 (GLOBE NEWSWIRE) -- Quit Genius, the world's first digital clinic for treating multiple substance addictions, and Evry Health, a modern business-to-business health insurance company, announced today they have partnered to deliver Quit Genius solutions to Evry Health's members in Dallas starting in April 2022.",
    articleLink:
      'https://www.globenewswire.com/news-release/2022/04/06/2417640/0/en/Digital-Clinic-for-Addiction-Quit-Genius-and-Tech-Savvy-Health-Insurance-Company-Evry-Health-Partner-to-Address-Drug-Addiction-and-Behavior-Modification-Head-On.html',
  },
  {
    companyLogo: 'MobiHealth-News-Logo.png',
    companyLogoAltText: 'MobiHealthNews Logo',
    articleTitle:
      'Quit Genius expands further into insurer space with new Evry Health deal',
    articleSummary:
      "Addiction recovery platform Quit Genius is diving into the payer space thanks to a new partnership with B2B insurance company Evry Health. As part of the deal, Evry Health's Dallas-based members will have access to Quit Genius' digital services, which include treatment for tobacco, alcohol and opioid addiction.",
    articleLink:
      'https://www.mobihealthnews.com/news/quit-genius-expands-further-insurer-space-new-evry-health-deal',
  },
  {
    companyLogo: 'D-Magazine-Logo.png',
    companyLogoAltText: 'D Magazine Logo',
    articleTitle:
      "DFW Healthcare Brief: Parkland Rebrand and UTA's Massive Cancer Database",
    articleSummary:
      'Parkland Health and Hospital System will now do business as Parkland Health.',
    articleLink:
      'https://www.dmagazine.com/healthcare-business/2022/02/dfw-healthcare-brief-parkland-rebrand-and-utas-massive-cancer-database/',
  },
  {
    companyLogo: 'KRLD-AM-Logo.png',
    companyLogoAltText: 'KRLD-AM (Dallas, TX) Logo',
    articleTitle: 'Chris Gay, Founder & CEO, Evry Health',
    articleSummary:
      'KRLD CEO Spotlight with Chris Gay, the founder and CEO of Evry Health.',
    articleLink:
      'https://www.audacy.com/krld/podcasts/ceo-spotlight-743/chris-gay-founder-ceo-evry-health-1086692668',
  },
  {
    companyLogo: 'D-Magazine-Logo.png',
    companyLogoAltText: 'D Magazine Logo',
    articleTitle:
      "What If Your Health Insurance Plan Didn't Have a Deductible?",
    articleSummary:
      "Health insurance deductibles are rising, but a local startup is upending the insurance industry with plans that don't have deductibles and copays.",
    articleLink:
      'https://www.dmagazine.com/healthcare-business/2021/12/what-if-your-health-insurance-plan-didnt-have-a-deductible/',
  },
  {
    companyLogo: 'Dallas-Innovates-logo.png',
    companyLogoAltText: 'Dallas Innovates Logo',
    articleTitle:
      "Dallas-Based Evry Health Wants to Make Accessing Healthcare 'as Easy as Ordering a Pizza'",
    articleSummary:
      'Signing up for healthcare or paying a doctor\'s bill should be as easy as ordering a pizza," says Chris Gay, co-founder and CEO of Evry Health. His Dallas-based B2B health insurance company has emerged from stealth to make healthcare just that simple—with a high-tech, mobile-first approach focused on preventative health and reducing costs for mid-sized companies.',
    articleLink:
      'https://dallasinnovates.com/dallas-based-evry-health-wants-to-make-accessing-healthcare-as-easy-as-ordering-a-pizza/',
  },
  {
    companyLogo: 'built-in-logo.png',
    companyLogoAltText: 'Built In Logo',
    articleTitle:
      'Dallas-Based B2B Insurance Startup Evry Health Launches From Stealth',
    articleSummary:
      'Chris Gay, co-founder of Dallas-based pay-per-mile car insurance company MileMeter, recently brought his personalized health insurance startup Evry Health to Dallas businesses.',
    articleLink:
      'https://builtin.com/dallas-fort-worth/startup-evry-health-launches-from-stealth-112421',
  },
  {
    companyLogo: 'Dallas-Business-Journal-Logo.png',
    companyLogoAltText: 'Dallas Business Journal Logo',
    articleTitle:
      'Dallas startup emerges from stealth to take on the health insurance industry',
    articleSummary:
      'Seeing friends and family pass away exposed dysfunctions in the U.S. health care system for local entrepreneur Chris Gay and his fellow co-founders, leading to the launch of their new Dallas-based venture.',
    articleLink:
      'https://www.bizjournals.com/dallas/inno/stories/news/2021/11/24/evry-health-chris-gay.html',
  },
  {
    companyLogo: 'Health-tech-hotspot-logo.png',
    companyLogoAltText: 'HealthTech HotSpot Logo',
    articleTitle:
      'New Tech-Savvy Health Insurance Company Evry Health Launches in Dallas',
    articleSummary:
      'DALLAS–(BUSINESS WIRE)–#EvryHealth–Dallas-based Evry Health is serious about delivering reliable, value-based care to Dallas-Fort Worth residents, and recently launched its new, tailor-made healthcare plans via www.evryhealth.com. A business-to-business health insurance company founded in 2017, Evry Health differentiates itself from traditional preferred provider organizations (PPOs) and health maintenance organization (HMOs) by using software automation to lower the cost of healthcare.',
    articleLink:
      'https://healthtechhotspot.com/new-tech-savvy-health-insurance-company-evry-health-launches-in-dallas/',
  },
  {
    companyLogo: 'Business-Wire-Logo.png',
    companyLogoAltText: 'Business Wire Logo',
    articleTitle:
      'New Tech-Savvy Health Insurance Company Evry Health Launches in Dallas',
    articleSummary:
      'DALLAS--(BUSINESS WIRE)--Dallas-based Evry Health is serious about delivering reliable, value-based care to Dallas-Fort Worth residents, and recently launched its new, tailor-made healthcare plans via www.evryhealth.com.',
    articleLink:
      'https://www.businesswire.com/news/home/20211117006298/en/New-Tech-Savvy-Health-Insurance-Company-Evry-Health-Launches-in-Dallas',
  },
  {
    companyLogo: 'Leaders-playbook-logo_.png',
    companyLogoAltText: "The Leader's Playbook Logo",
    articleTitle:
      "The Leader's Playbook\nEntrepreneurship and Beyond with Chris Gay",
    articleSummary:
      "Join us on this episode as Justin is joined by Chris Gay, CEO and Cofounder of Evry Health, to discuss Evry Health, the in's and outs of business and entrepreneurship, and the importance of listening.",
    articleLink:
      'https://podcastaddict.com/episode/https%3A%2F%2Fapi.spreaker.com%2Fdownload%2Fepisode%2F51339294%2Fchris_audio.mp3&podcastId=4100766',
  },
  {
    companyLogo: 'Leaders-playbook-logo_.png',
    companyLogoAltText: "The Leader's Playbook Logo",
    articleTitle: 'Entrepreneurship and Beyond with Chris Gay',
    articleSummary:
      "Join us on this episode as Justin is joined by Chris Gay, CEO and Cofounder of Evry Health, to discuss Evry Health, the in's and outs of business and entrepreneurship, and the importance of listening.",
    articleLink: 'https://www.youtube.com/watch?app=desktop&v=4VUctgD_0sI',
  },
]
